import { useLocation } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import EmailBreakdownButton from './EmailBreakdownButton';
import RetakeExamButton from './RetakeExamButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { HasParentPlaylist, NextPlaylistContent } from '../../playlistContent/index.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ExamFinishedNextSteps = ({
  marginBlockStart = '0',
  marginInlineStart,
  to
}) => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: marginBlockStart,
    marginInlineStart: marginInlineStart,
    children: /*#__PURE__*/_jsx(ACRouterButton, {
      "data-test-id": "exam-next-steps",
      to: Object.assign({}, location, {
        pathname: to
      }),
      use: to === '/' ? 'tertiary-light' : 'secondary',
      children: to === '/' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.backToLearningTracks"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.next"
      })
    })
  });
};
const ExamFinishedSecondaryButtons = ({
  retake,
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  const {
    isMobile
  } = useMediaQuery();
  if (!mostRecentExamAttempt || !track || !pendingPracticalExercises) {
    return null;
  }
  const nextSteps = ({
    marginBlockStart,
    marginInlineStart
  } = {}) => /*#__PURE__*/_jsx(HasParentPlaylist, {
    fallback: /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
      marginBlockStart: marginBlockStart,
      marginInlineStart: marginInlineStart,
      to: "/"
    }),
    children: /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        url,
        showPlaylistNavigatorCta
      }) => /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
        to: showPlaylistNavigatorCta ? url : '/'
      }),
      trackId: track.id
    })
  });
  if (isMobile) {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: "column",
        gap: "200",
        children: [retake && /*#__PURE__*/_jsx(RetakeExamButton, {
          mostRecentExamAttempt: mostRecentExamAttempt,
          use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
          withTooltip: true
        }), nextSteps(), /*#__PURE__*/_jsx(EmailBreakdownButton, {
          marginBlockStart: "300",
          mostRecentExamAttempt: mostRecentExamAttempt,
          paddingBlock: "200",
          tooltipTitle: !mostRecentExamAttempt.attemptFinishTime && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.exams.finished.breakdownUnavailable"
          }),
          trackId: track.id
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailBreakdownButton, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      tooltipTitle: !mostRecentExamAttempt.attemptFinishTime && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.breakdownUnavailable"
      }),
      trackId: track.id
    }), /*#__PURE__*/_jsx(RetakeExamButton, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
      withTooltip: true
    }), nextSteps()]
  });
};
export default ExamFinishedSecondaryButtons;